import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { BudgetService } from 'src/app/services/budget.service';
import { DatosService } from 'src/app/clients/servicios/datos.service';


@Component({
  selector: 'app-budgets',
  templateUrl: './budgets.component.html',
  styleUrls: ['./budgets.component.scss']
})
export class BudgetsComponent implements OnInit {
  public selectedBudget = null
  public budgets = [ ] 
  public budgetForm: FormGroup;
  public displayForm = false
  public submitted = false;
  public isEditForm = false;
  public displaySuccess = false;

  constructor( private budgetService : BudgetService, public _datosService : DatosService) { }

  ngOnInit() {
    this.budgetForm = new FormGroup({
      'stimated_price': new FormControl('', [Validators.required]),
      'stimated_time': new FormControl('',[Validators.required]),
      'message': new FormControl('', []),
      'id': new FormControl('')
    });
    this.budgetService.getBudgets().subscribe((budgetnapshot) => {
      this.budgets = [];
      budgetnapshot.forEach((budgetData: any) => {
        this.budgets.push(Object.assign(
          {id: budgetData.payload.doc.id, status: 'Pendiente'},
          budgetData.payload.doc.data()
        ));
      })
    });
   }

  selectBudget(budget) {
    const formElement = document.querySelector("#budget-form");
    if (formElement) formElement.scrollIntoView({ behavior: 'smooth', block: 'start' })
    this.currentPhoto = 0;
    this.displaySuccess = false;
    this.selectedBudget = budget
    this.budgetForm.patchValue(budget);
  }


  deleteBudget(){
      this.budgetService.deletebudget(this.f.id.value);
      this.onReset()
    }

  onSubmit(){
    this.submitted = true;
    if (this.budgetForm.valid){
      let formData = this.budgetForm.value;
      formData['status'] = 'Completado';
        this.budgetService.updateBudget(formData)
        .then(() => {
          this.displaySuccess = true;
          this.onReset()
        })
    }
  }

  onReset(){
    this.submitted = false;
    this.budgetForm.reset();
    this.displayForm = false;
    this.isEditForm = false;
    this.selectedBudget = null;
  }

  get f(){
    return this.budgetForm.controls;
  }

  get formSubmitValue(){
   return "Actualizar Presupuesto"
  }

  currentPhoto = 0

  siguiente(){
    this.currentPhoto++
    if( this.currentPhoto == this.selectedBudget.photos.length ){
      this.currentPhoto = 0
    }
  }

  anterior(){
    if( this.currentPhoto == 0 ){
      this.currentPhoto = this.selectedBudget.photos.length
    } 
    this.currentPhoto--
  }

  establecer(i){
    this.currentPhoto = i
  }
}
